import React from "react";
const LayoutGroupContext = React.createContext({});
export { LayoutGroupContext };
//# sourceMappingURL=LayoutGroupContext.mjs.map
